import { Button } from '@mantine/core'

import styles from './ResetButton.module.css'

export const ResetButton = ({
  onClick,
  disabled,
  label = 'Reset',
}: {
  onClick: (val: string) => void
  disabled: boolean
  label?: string
}) => (
  <Button
    className={styles.reset}
    variant="outline"
    onClick={() => onClick('')}
    disabled={disabled}
    size="sm"
  >
    {label}
  </Button>
)
